module.exports = __webpack_public_path__ + "static/media/video-retraining-es.ea32e87f.vtt";